
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { AliExpressLinks } from "@/data/parts";
import { ExternalLink } from "lucide-react";

interface PartLinksProps {
  amazonLink?: string;
  aliExpressLink?: string | AliExpressLinks;
  videoGuide?: string;
  writtenGuide?: string;
  printedParts?: string;
}

const PartLinks = ({ amazonLink, aliExpressLink, videoGuide, writtenGuide, printedParts }: PartLinksProps) => {
  // Check if aliExpressLink is an object with multiple links
  const hasMultipleAliExpressLinks = aliExpressLink && typeof aliExpressLink === 'object';

  return (
    <div className="grid grid-cols-2 gap-2 mt-auto w-full">
      {amazonLink && (
        <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
          <a href={amazonLink} target="_blank" rel="noopener noreferrer">
            Amazon
          </a>
        </Button>
      )}
      
      {aliExpressLink && !hasMultipleAliExpressLinks && (
        <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
          <a href={aliExpressLink as string} target="_blank" rel="noopener noreferrer">
            AliExpress
          </a>
        </Button>
      )}
      
      {hasMultipleAliExpressLinks && (
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500">
              AliExpress
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle>Choose Printer</DialogTitle>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              {(aliExpressLink as AliExpressLinks).global && (
                <Button variant="outline" className="w-full justify-between px-4 whitespace-normal h-auto py-2 min-h-10 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
                  <a href={(aliExpressLink as AliExpressLinks).global} target="_blank" rel="noopener noreferrer">
                    <span>K1/K1C/K1SE</span> <ExternalLink className="h-4 w-4 flex-shrink-0 ml-2" />
                  </a>
                </Button>
              )}
              {(aliExpressLink as AliExpressLinks).us && (
                <Button variant="outline" className="w-full justify-between px-4 whitespace-normal h-auto py-2 min-h-10 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
                  <a href={(aliExpressLink as AliExpressLinks).us} target="_blank" rel="noopener noreferrer">
                    <span>K1 Max</span> <ExternalLink className="h-4 w-4 flex-shrink-0 ml-2" />
                  </a>
                </Button>
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}

      {videoGuide && (
        <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
          <a href={videoGuide} target="_blank" rel="noopener noreferrer">
            Video Guide
          </a>
        </Button>
      )}
      
      {writtenGuide && (
        <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
          <a href={writtenGuide} target="_blank" rel="noopener noreferrer">
            Written Guide
          </a>
        </Button>
      )}
      
      {printedParts && (
        <Button variant="outline" size="sm" className="text-xs w-full whitespace-normal h-auto py-1 min-h-9 text-center border-gray-300 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-500" asChild>
          <a href={printedParts} target="_blank" rel="noopener noreferrer">
            Printed Parts
          </a>
        </Button>
      )}
    </div>
  );
};

export default PartLinks;
